import { FileEdit, X } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import type { PendingProposalSession } from './closerLeadProposalFlow.util'

type Props = {
  session: PendingProposalSession
  onResume: () => void
  onDismiss: () => void
}

export function PendingProposalResumeBanner({ session, onResume, onDismiss }: Props) {
  const label = session.empresa?.trim() || 'este lead'

  return (
    <div className='glass-card flex flex-col gap-3 border border-amber-500/25 bg-amber-500/[0.06] p-4 sm:flex-row sm:items-center sm:justify-between'>
      <div className='min-w-0'>
        <p className='text-sm font-semibold text-text-primary'>Proposta em andamento</p>
        <p className='mt-0.5 text-xs text-text-muted'>
          Você estava elaborando a proposta de <span className='font-medium text-text-primary'>{label}</span>.
          Continue de onde parou.
        </p>
      </div>
      <div className='flex shrink-0 flex-wrap items-center gap-2'>
        <Button
          variant='primary'
          size='sm'
          icon={<FileEdit size={14} />}
          onClick={onResume}
        >
          Continuar proposta
        </Button>
        <Button variant='ghost' size='sm' icon={<X size={14} />} onClick={onDismiss}>
          Dispensar
        </Button>
      </div>
    </div>
  )
}
